import axios from '@/services/axios'
import appsettings from '@/appsettings'

export async function depositAmount({ tenantId, amount }) {
  if (appsettings.apiDebugMessages) console.log('depositApi.depositAmount.request', { tenantId, amount })
  const response = await axios().post(`deposits`, { tenantId, amount })
  if (appsettings.apiDebugMessages) console.log('depositApi.depositAmount.response', response)
  return response.data
}